import { overviewSlideInterface } from '@features/lci-report/slides/overview-slide-interface';
import { formatters } from '@utils/formattersV2';
import { BuildPresentationProps } from './build-presentation';

const valueIfPresent = (value: string | undefined) =>
  value && value.length > 0 ? value : null;

export const overviewSlideFromProps = (
  props: BuildPresentationProps,
  slideMaster: string
) => {
  if (!props.customFields.includedSlides.overall.overview) return [];

  const reportingDimensions = props.report.dimensions.map(dim => {
    const dimension = (
      props.customFields.dimensions as Record<
        string,
        BuildPresentationProps['customFields']['dimensions']['ds']
      >
    )[dim.dimensionName];
    return (
      valueIfPresent(dimension?.salesTableHeader) ??
      valueIfPresent(dimension?.visitsTableHeader) ??
      dim.dimensionName
    );
  });

  return [
    overviewSlideInterface({
      flightDates: [props.campaign.startDate, props.campaign.endDate],
      measurementDates: [props.campaign.startDate, props.selectedReportDate],
      metrics: [
        {
          name: 'Impressions',
          value: formatters.number(props.report.impressions, { full: true }),
        },
        {
          name: 'Users Matched for Attribution',
          value: formatters.number(props.report.matchedForAttribution, {
            full: true,
          }),
        },
        {
          name: 'Unique Users',
          value: formatters.number(props.report.uniqueUsers, { full: true }),
        },
        {
          name: 'Media Spend',
          value: formatters.currency(props.calculatedFields.adSpend ?? 0, {
            full: true,
            decimals: 0,
          }),
        },
      ],
      reportsIncluded: [
        ...(props.report.hasVisitMetrics ? ['Visit Attribution'] : []),
        'Sales Attribution',
      ],
      reportingDimensions,
      slideMaster,
    }),
  ];
};
